import { useState } from 'react';
import { Select, type SelectProps } from 'antd';
import { useListCounterpartiesQuery } from '../api/counterpartyApi';

export interface CounterpartySelectProps {
  value?: string;
  onChange: (id: string | undefined) => void;
  disabled?: boolean;
  placeholder?: string;
  /** Скрыть эту карточку из списка (например, саму себя при выборе дубликата для «Объединить с…»). */
  excludeId?: string;
}

export function CounterpartySelect({ value, onChange, disabled, placeholder = 'Контрагент', excludeId }: CounterpartySelectProps) {
  const [q, setQ] = useState('');
  const { data = [], isFetching } = useListCounterpartiesQuery({ q: q || undefined });

  const handleChange: SelectProps<string>['onChange'] = (id) => onChange(id);

  return (
    <Select<string>
      value={value}
      allowClear
      showSearch
      filterOption={false}
      disabled={disabled}
      loading={isFetching}
      placeholder={placeholder}
      style={{ width: '100%', minWidth: 220 }}
      onSearch={setQ}
      onChange={handleChange}
      options={data.filter((c) => c.id !== excludeId).map((c) => ({ value: c.id, label: c.name }))}
    />
  );
}
